// extracted by mini-css-extract-plugin
export default {"wrapper":"kx-z","response":"lx-z","error":"mx-z","disabled":"nx-z","buttons":"ox-z","feedbackQuestionSection":"px-z","yesNoWrapper":"qx-z"};